module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1290.840d39d4.png";